var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShieldCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.59935 5.99868C6.20927 5.94971 9.49836 4.57239 12 2.33334C14.5017 4.57239 17.7908 5.94971 21.4007 5.99868C21.5318 6.77961 21.6 7.58185 21.6 8.40003C21.6 14.6699 17.5929 20.0038 12 21.9806C6.4071 20.0038 2.40002 14.6699 2.40002 8.40003C2.40002 7.58185 2.46826 6.77961 2.59935 5.99868ZM16.4486 10.4485C16.9172 9.97989 16.9172 9.2201 16.4486 8.75147C15.9799 8.28284 15.2201 8.28284 14.7515 8.75147L10.8 12.7029L9.24855 11.1515C8.77992 10.6828 8.02012 10.6828 7.5515 11.1515C7.08287 11.6201 7.08287 12.3799 7.5515 12.8485L9.9515 15.2485C10.4201 15.7172 11.1799 15.7172 11.6486 15.2485L16.4486 10.4485Z",
    fill: "#4FC0CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCheck);
export default __webpack_public_path__ + "static/media/shield-check.e8c7c3bfaf131af87107a728214bf556.svg";
export { ForwardRef as ReactComponent };